import { render, staticRenderFns } from "./UploadPartnersFromExcel.vue?vue&type=template&id=8c9e63b2&"
import script from "./UploadPartnersFromExcel.vue?vue&type=script&lang=js&"
export * from "./UploadPartnersFromExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports